import { logger, initializeNeuroGuide } from '@ignitesales/neuro-application';
import App from "../../../../../_themes/regionsOnlineTheme/src/shared/js/App.jsx";
import messages from '../i18n/messages';
import {questionLayouts} from '../../../../../_themes/regionsOnlineTheme/src/shared/js/components/questions/index.mjs';
import regionsOnlineConsumerReducer from "../../../../../_themes/regionsOnlineTheme/src/shared/js/reducers/regions-online-consumer-reducer.mjs";
import AppLoading from '../../../../../_themes/regionsOnlineTheme/src/shared/js/AppLoading';
import loadFonts from '../../../../../_themes/regionsOnlineTheme/src/shared/js/utils/loadFonts.mjs';
import analyticsReducer from '../../../../../_themes/regionsOnlineTheme/src/shared/js/reducers/analytics-reducer';
import customMessages from "../i18n/custom";

const initGuide = async () => {
  loadFonts();
  await initializeNeuroGuide({
    AppComponent: App,
    AppLoadingComponent: AppLoading,
    messages: messages,
    reducers: [ analyticsReducer, regionsOnlineConsumerReducer ],
    guideConfig: {
      customMessages: customMessages,
      questionLayouts,
      errorValidations: {
        useInlineError: true,
        options: {
          inlineTag: 'div',
          inlinePosition: 'afterLabel',
        }
      },
    }
  });

  logger.info('Guide application is ready for takeoff!');
};

initGuide();
